/**
 * The pieces of a locations import that are plain arithmetic: the template we
 * offer, how a file's rows are cut up to send, and what came back.
 */

export const LOCATION_TEMPLATE_HEADERS = [
  'name',
  'address_line1',
  'address_line2',
  'city',
  'state',
  'postal_code',
  'phone',
  'website',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
  'pickup',
  'delivery',
  'fns_number',
  'external_id',
] as const;

const EXAMPLE = ['Example Market — Main St', '123 Main St', '', 'Charlotte', 'NC', '28205', '(704) 555-0100', 'example.com', '0800-2000', '0800-2000', '0800-2000', '0800-2000', '0800-2000', '0900-1800', 'closed', 'yes', 'no', '', '101'];

/** A file with the right headings and one row to write over. */
export function locationTemplateCsv(): string {
  const line = (cells: readonly string[]) => cells.map((c) => (/[",\n]/.test(c) ? `"${c.replace(/"/g, '""')}"` : c)).join(',');
  return `\uFEFF${line(LOCATION_TEMPLATE_HEADERS)}\r\n${line(EXAMPLE)}\r\n`;
}

export type LocationRowStatus = 'ready' | 'added' | 'skipped' | 'refused';

export interface LocationRowResult {
  r: number;
  name: string;
  status: LocationRowStatus;
  address?: string;
  code?: string;
  value?: string | null;
  storeId?: string;
}

/** Each row is looked up on a map, so they go a few at a time. */
export const LOCATION_PIECE = 5;

export function pieces<T>(rows: T[], size = LOCATION_PIECE): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < rows.length; i += size) out.push(rows.slice(i, i + size));
  return out;
}

export function tally(results: LocationRowResult[]): Record<LocationRowStatus, number> {
  const counts: Record<LocationRowStatus, number> = { ready: 0, added: 0, skipped: 0, refused: 0 };
  for (const r of results) counts[r.status]++;
  return counts;
}
